import React from 'react';
import {
    Provider, lightTheme, Dialog, Button, ActionButton, DialogTrigger, Divider,
    Heading, Content, ButtonGroup
} from '@adobe/react-spectrum';

const DeleteDialog = (props) => {
    const onCloseHandler = () => {
        props.handleCloseDialog(false);
    }
    const onDeleteConfirmHandler = () => {
        props.handleCloseDialog(true);
    }
return (
    <Provider theme={lightTheme}>
        <div>
            <DialogTrigger
                type="modal"
                mobileType="modal"
                isOpen = {props.isDialogOpened}
                defaultOpen= {false}>
                <ActionButton isHidden isQuiet></ActionButton>
                <Dialog size="S">
                    <Heading>Delete {props.entity}</Heading>
                    <Divider />
                    <Content>Are you sure, you want to delete?</Content>
                    <ButtonGroup>
                        <Button variant="warning" onPress={onCloseHandler}>Cancel</Button>
                        <Button variant="primary" onPress={onDeleteConfirmHandler}>Confirm</Button>
                    </ButtonGroup>
                </Dialog>
            </DialogTrigger>
        </div>
    </Provider>
    );
                    
};

export default DeleteDialog;